import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'

interface Props {
  error: Error
  resetErrorBoundary: () => void
}

export const FallbackRender: React.FC<Props> = ({
  error,
  resetErrorBoundary,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  function onClickHandler() {
    // Call resetErrorBoundary() to reset the error boundary and retry the render
    resetErrorBoundary()

    // Navigate back to the start page
    navigate('/')
  }

  return (
    <>
      {/* Center div horizontal and vertical */}
      <div className="flex flex-column flex-grow-1 align-items-center justify-content-center">
        <div>
          {/* Error icon */}
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: '3rem', color: 'var(--red-500)' }}
          ></i>

          {/* Text */}
          <h2>{t('fallbackRender.titles.error')}</h2>
          <p>{t('fallbackRender.content.description')}</p>
          <p className="mb-4">
            {t('fallbackRender.errors.code')} {error.message}
          </p>

          {/* Back to home button */}
          <Button onClick={onClickHandler}>
            {t('common.buttons.backToHome')}
          </Button>
        </div>
      </div>
    </>
  )
}
